import { render, staticRenderFns } from "./left-menu.vue?vue&type=template&id=30f33f6e&scoped=true&"
import script from "./left-menu.vue?vue&type=script&lang=js&"
export * from "./left-menu.vue?vue&type=script&lang=js&"
import style0 from "./left-menu.vue?vue&type=style&index=0&id=30f33f6e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "30f33f6e",
  null
  
)

export default component.exports